//@flow
import React, {createContext, useState} from 'react';
import {Drawer, makeStyles} from '@material-ui/core';
import {classNames} from '../../../utils/react';
import {DRAWER_WIDTH, SHRUNK_DRAWER_WIDTH} from '../../../layouts/constants';

type Props = {
  children: React$Node,
};

const useStyles = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    borderRight: 'none',
    transition: 'all 0.3s ease-in-out',
    width: DRAWER_WIDTH,
  },
  rootShrink: {
    width: SHRUNK_DRAWER_WIDTH,
  },
  paperAnchorDockedLeft: {
    border: 'none',
    boxShadow: '4px 0px 12px rgba(222, 222, 222, 0.25)',
    transition: 'all 0.3s ease-in-out',
    width: DRAWER_WIDTH,
    overflow: 'unset',
  },
  paperAnchorDockedLeftShrink: {
    width: SHRUNK_DRAWER_WIDTH,
  },
}));

type ContextProps = {
  shrink: boolean,
  setShrink: (value: boolean) => void,
  toggleShrink: () => void,
};

const SidebarContext = createContext<ContextProps | null>(null);

export function useSidebarContext(): ContextProps {
  const context = React.useContext(SidebarContext);

  if (!context) {
    throw new Error(
      'useSidebarContext must be used within a SidebarContextProvider'
    );
  }

  return context;
}

export default function SidebarContainer({children}: Props) {
  const classes = useStyles();

  const [shrink, setShrink] = useState(false);

  const toggleShrink = () => {
    setShrink(ps => !ps);
  };

  const rootClasses = classNames(classes.root, {
    [classes.rootShrink]: shrink,
  });

  const paperClasses = classNames(classes.paperAnchorDockedLeft, {
    [classes.paperAnchorDockedLeftShrink]: shrink,
  });

  return (
    <SidebarContext.Provider
      value={{
        shrink,
        setShrink,
        toggleShrink,
      }}
    >
      <Drawer
        variant="permanent"
        classes={{
          root: rootClasses,
          paperAnchorDockedLeft: paperClasses,
        }}
        anchor="left"
      >
        {children}
      </Drawer>
    </SidebarContext.Provider>
  );
}
